module.exports = __webpack_public_path__ + "static/media/logo192-transparent.defb30a8.png";